
import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Bookmark, Award, Users } from "lucide-react";
import { Account } from "@/types/strategy-types";

interface AccountSummaryCardProps {
  accounts?: Account[];
  leadAccounts?: any[];
}

const AccountSummaryCard: React.FC<AccountSummaryCardProps> = ({
  accounts,
  leadAccounts
}) => {
  return (
    <Card className="col-span-1">
      <CardHeader>
        <CardTitle>Account Stats</CardTitle>
        <CardDescription>
          Overview of lead and trading accounts
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Bookmark className="h-4 w-4 text-muted-foreground" />
              <span>Lead Accounts:</span>
            </div>
            <span className="font-medium">{leadAccounts?.length || 0}</span>
          </div>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Award className="h-4 w-4 text-muted-foreground" />
              <span>Trading Accounts:</span>
            </div>
            <span className="font-medium">{accounts?.length || 0}</span>
          </div>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Users className="h-4 w-4 text-muted-foreground" />
              <span>Active Trading Accounts:</span>
            </div>
            <span className="font-medium">
              {accounts ? accounts.filter(a => a.active).length : 0}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AccountSummaryCard;
